import useCanEnrollEp from "../../Hooks/useCanEnrollEp/useCanEnrollEp";

// Bouton « Suspension / Remobilisation » de la fiche allocataire : toujours
// visible pour qui a le droit d'inscrire en EP (réunion métier du 14/09/2026).
// C'est la modale qui lit le dossier et dit ce qui va se passer — y compris
// quand une demande est déjà en attente.
const SuspensionRemobilisationButton = ({ recipient, onClick }) => {
  const { canEnroll, isChecking } = useCanEnrollEp();

  if (isChecking || !canEnroll || !recipient?.id) return null;

  return (
    <button
      type="button"
      className="btn btn-outline-warning btn-sm mr-1 suspension-remobilisation__bouton"
      onClick={onClick}
    >
      <i className="fa fa-unlock-alt mr-2" aria-hidden="true" />
      Suspension / Remobilisation
    </button>
  );
};

export default SuspensionRemobilisationButton;
